import type { QTableColumn } from 'quasar';
import { formatDate } from 'src/utils/formatDate';
type PathItem = {
  id: string;
  name: string;
};
export type Path = {
  group_type: {
    id: string;
    name: string;
  };
  path_items: PathItem[];
};
export interface ResourceModelCreateAttributes {
  name: string;
  code: string;
  parent_ids: string[];
  resource_type_id: string;
  zip_code: string;
  prefecture_code: string | null;
  city_code: string | null;
  town_area: string;
  tel_number: string;
  lat: number;
  lng: number;
  description: string;
}
export interface ResourceModelUpdateAttributes {
  name: string;
  code: string;
  parent_ids: string[];
  resource_type_id: string;
  zip_code: string;
  prefecture_code: string | null;
  city_code: string | null;
  town_area: string;
  tel_number: string;
  lat: number;
  lng: number;
  description: string;
}
export interface ResourceGetAttributes {
  id: string;
  name: string;
  code: string;
  resource_type: {
    id: string;
    name: string;
  };
  parents: { id: string; name: string }[];
  zip_code: string;
  prefecture: { code: string; name: string } | null;
  city: { code: string; name: string } | null;
  town_area: string;
  tel_number: string;
  lat: number;
  lng: number;
  description: string;
  paths: Path[];
  created_at: string;
  updated_at: string;
}
export class ResourceModel {
  id: string;
  name: string;
  code: string;
  resource_type: {
    id: string;
    name: string;
  } | null;
  parents: { id: string; name: string }[];
  zip_code: string;
  prefecture: { code: string; name: string } | null;
  city: { code: string; name: string } | null;
  town_area: string;
  tel_number: string;
  lat: number;
  lng: number;
  description: string;
  paths: Path[];
  created_at: string;
  updated_at: string;

  constructor(input?: ResourceGetAttributes) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.code = input ? input.code : '';
    this.resource_type = input ? input.resource_type : null;
    this.parents = input ? input.parents : [];
    this.zip_code = input ? input.zip_code : '';
    this.prefecture = input ? input.prefecture : null;
    this.city = input ? input.city : null;
    this.town_area = input ? input.town_area : '';
    this.tel_number = input ? input.tel_number : '';
    this.lat = input ? input.lat : 0;
    this.lng = input ? input.lng : 0;
    this.description = input ? input.description : '';
    this.paths = input ? input.paths : [];
    this.created_at = input ? formatDate(input.created_at) : '';
    this.updated_at = input ? formatDate(input.updated_at) : '';
  }

  getId(): string {
    return this.id;
  }
  //getAttributes(): ResourceModelAttributes {}
  getCreateAttributes(): ResourceModelCreateAttributes {
    return {
      name: this.name,
      code: this.code,
      resource_type_id: this.resource_type?.id || '',
      parent_ids: this.parents.map((parent) => parent.id),
      zip_code: this.zip_code,
      prefecture_code: this.prefecture ? this.prefecture.code : null,
      city_code: this.city ? this.city.code : null,
      town_area: this.town_area,
      tel_number: this.tel_number,
      lat: this.lat ? Number(this.lat) : 0,
      lng: this.lng ? Number(this.lng) : 0,
      description: this.description,
    };
  }
  getUpdateAttributes(): ResourceModelUpdateAttributes {
    return {
      name: this.name,
      code: this.code,
      resource_type_id: this.resource_type?.id || '',
      parent_ids: this.parents.map((parent) => parent.id),
      zip_code: this.zip_code,
      prefecture_code: this.prefecture ? this.prefecture.code : null,
      city_code: this.city ? this.city.code : null,
      town_area: this.town_area,
      tel_number: this.tel_number,
      lat: this.lat ? Number(this.lat) : 0,
      lng: this.lng ? Number(this.lng) : 0,
      description: this.description,
    };
  }
}
export type ResourceCollection = ResourceModel[];

export const ResourceTableColumns: QTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    align: 'left',
    field: 'id',
    sortable: true,
  },
  {
    name: 'resource_type',
    label: 'リソースタイプ',
    align: 'left',
    field: 'resource_type',
    sortable: true,
    format: (val) => val.name,
  },
  {
    name: 'name',
    label: '名前',
    align: 'left',
    field: 'name',
    sortable: true,
  },
  {
    name: 'code',
    label: '識別コード',
    align: 'left',
    field: 'code',
    sortable: true,
  },
  {
    name: 'prefecture_code',
    label: '都道府県',
    align: 'left',
    field: 'prefecture_code',
    sortable: true,
  },
  {
    name: 'city_code',
    label: '市区町村',
    align: 'left',
    field: 'city_code',
    sortable: true,
  },
  {
    name: 'updated_at',
    label: '更新日',
    align: 'left',
    field: 'updated_at',
    sortable: true,
  },
];
